/** Rolling last 365 days */
export const INSIGHT_TIME_RANGE_LAST_12_MONTHS = 365;

/** Calendar year: 1 Jan through today */
export const INSIGHT_TIME_RANGE_THIS_YEAR = 366;

export interface InsightTimeRangeSavePayload {
  insightTimeRangeDays: number;
  insightCustomStartDate: string | null;
  insightCustomEndDate: string | null;
}

export function getCalendarYearWindow(referenceDate = new Date()): {
  startDate: string;
  endDate: string;
  days: number;
} {
  const year = referenceDate.getFullYear();
  const startDate = `${year}-01-01`;
  const endDate = referenceDate.toISOString().slice(0, 10);
  const start = new Date(`${startDate}T00:00:00`);
  const end = new Date(`${endDate}T00:00:00`);
  const days = Math.max(1, Math.round((end.getTime() - start.getTime()) / 86400000) + 1);
  return { startDate, endDate, days };
}

export function buildInsightTimeRangeSavePayload(
  selectedValue: number
): InsightTimeRangeSavePayload {
  if (selectedValue === INSIGHT_TIME_RANGE_THIS_YEAR) {
    const { startDate, endDate } = getCalendarYearWindow();
    return {
      insightTimeRangeDays: INSIGHT_TIME_RANGE_THIS_YEAR,
      insightCustomStartDate: startDate,
      insightCustomEndDate: endDate,
    };
  }

  return {
    insightTimeRangeDays: selectedValue,
    insightCustomStartDate: null,
    insightCustomEndDate: null,
  };
}

export function resolveInsightTimeRangeSelection(
  days: number,
  customStartDate?: string | null,
  customEndDate?: string | null
): number {
  if (days === INSIGHT_TIME_RANGE_THIS_YEAR) {
    return INSIGHT_TIME_RANGE_THIS_YEAR;
  }

  const year = new Date().getFullYear();
  if (customStartDate === `${year}-01-01` && customEndDate) {
    return INSIGHT_TIME_RANGE_THIS_YEAR;
  }

  return days;
}

export function resolveInsightTimeRangeSelectionFromWindow(
  storedDays: number,
  windowStartDate?: string | null,
  windowEndDate?: string | null
): number {
  const year = new Date().getFullYear();
  if (windowStartDate === `${year}-01-01` && windowEndDate) {
    return INSIGHT_TIME_RANGE_THIS_YEAR;
  }
  return resolveInsightTimeRangeSelection(storedDays);
}

export function formatCalendarYearLabel(referenceDate = new Date()): string {
  return `This Year (${referenceDate.getFullYear()})`;
}

export function formatInsightTimeRangeLabel(
  selectedValue: number,
  referenceDate = new Date()
): string {
  if (selectedValue === INSIGHT_TIME_RANGE_THIS_YEAR) {
    return formatCalendarYearLabel(referenceDate);
  }
  if (selectedValue === INSIGHT_TIME_RANGE_LAST_12_MONTHS) {
    return 'Last 12 months';
  }
  return `${selectedValue} days`;
}
